export default __webpack_public_path__ + "static/media/cartKlein.6a6ff959.jpg";